import { ShoppingCart } from "lucide-react";
import { CartProps } from "./CartProps";
import withRouter, { WithRouterProps } from "Common/withRouter";
import { useEffect, useState } from "react";
import { WithNotificationsProps } from "Common/withNotifications";
import withNotifications from 'Common/withNotifications';
import { NotificationType } from "../Notifications/notificationTypes";
import { WithAuthProps } from "../Authentication/WithAuthProps";
import withAuth from "../Authentication/withAuth";
import { axios_helper_async } from "helpers/Axios";
import withMessages, { WithMessagesProps } from "Common/withMessages";
import { WithCartProps } from "./WithCartProps";
import { withCart } from "./withCart";

const Cart: React.FC<CartProps & WithRouterProps & WithNotificationsProps & WithAuthProps & WithMessagesProps & WithCartProps> = ({
    router,
    notifications,
    messages,
    account,
    cart
}) => {
    // const [items, setItems] = useState<number>(0);

    // const getItemsCount = async () => {
    //     try{
            
    //         const body = {
    //             customerId: account.id
    //         }

    //         const response = await axios_helper_async<number>("/Cart/Get-Cart-Count", 'GET', body);

    //         messages.setMessages(response.messages);
    //         notifications.setNotifications(response.notifications);

    //         if(response.isSuccess && response.data !== null){
    //             setItems(response.data);
    //         }            
    //     }
    //     catch(ex: any){
    //         notifications.showNotification(`${ex}`, NotificationType.Error);
    //     }
    //     finally{

    //     }
    // }

    useEffect(() => {
        if(account.isAuthenticated){
            (async () => {
                //await getItemsCount();
                cart.updateCart();
            })();
        }
    }, [account.isAuthenticated]);

    return(
        <div className="relative flex items-center h-header">
            <button type="button" data-drawer-target="cartSidePenal" className="inline-flex relative justify-center items-center p-0 text-topbar-item transition-all w-[37.5px] h-[37.5px] duration-200 ease-linear bg-topbar rounded-md btn hover:bg-topbar-item-bg-hover hover:text-topbar-item-hover group-data-[topbar=dark]:bg-topbar-dark group-data-[topbar=dark]:hover:bg-topbar-item-bg-hover-dark group-data-[topbar=dark]:hover:text-topbar-item-hover-dark group-data-[topbar=brand]:bg-topbar-brand group-data-[topbar=brand]:hover:bg-topbar-item-bg-hover-brand group-data-[topbar=brand]:hover:text-topbar-item-hover-brand group-data-[topbar=dark]:dark:bg-zink-700 group-data-[topbar=dark]:dark:hover:bg-zink-600 group-data-[topbar=brand]:text-topbar-item-brand group-data-[topbar=dark]:dark:hover:text-zink-50 group-data-[topbar=dark]:dark:text-zink-200 group-data-[topbar=dark]:text-topbar-item-dark" onClick={() => router.navigate("/cart")}>
                <ShoppingCart className="inline-block w-5 h-5 stroke-1 fill-slate-100 group-data-[topbar=dark]:fill-topbar-item-bg-hover-dark group-data-[topbar=brand]:fill-topbar-item-bg-hover-brand"></ShoppingCart>
                <span className="absolute flex items-center justify-center w-[20px] h-[20px] text-xs text-white bg-red-400 border-white rounded-full -top-1 -right-1">{cart.items}</span>
            </button>
        </div>
    )
}

export default withRouter(withNotifications(withAuth(withMessages(withCart(Cart)))));